export const BYTE = {
	MB: 1024 * 1024,
} as const;
